import React from "react";
import { Modal } from "react-bootstrap";
import "./loadingOverlayModal.css";

const LoadingOverlayModal = () => {
  return (
    <div className="loadingOverlayModal">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal loadingOverlayDialog"
        show={true}
      >
        <Modal.Body className="loadingOverlayModalBody figma-drop-shadow">
          <div className="onboardingCopyTradeContent">
            <div className="loadingOverlayModalWrap">
              <div className="loading-4">
                <span className="span1"></span>
                <span className="span2"></span>
                <span className="span3"></span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LoadingOverlayModal;
